import { SubmitApi } from 'api/SubmitApi';

import { backendReadApiClient } from './backendApiClient';
import { projectSubmitMapper } from './projectSubmitMapper';

export const submitApi = new SubmitApi(backendReadApiClient, projectSubmitMapper);
